(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'GoogleConversionTracking';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googleconversiontracking", TrackingModel);

        if (!Tracker || !Tracker.Properties.GoogleConversionId || !Tracker.Properties.GoogleConversionLabel)
            return;

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        Init();

        function Init() {
            if (!CanTrack) return;

            LhApp.Function.Tracking.InitGoogleTagManager();

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                window.google_conversion_id = Tracker.Properties.GoogleConversionId;
                                window.google_conversion_label = Tracker.Properties.GoogleConversionLabel;
                                window.google_conversion_value = TrackingModel.Order.TotalPriceN;
                                window.google_conversion_currency = LhApp.Context.Currency.Code;
                                window.google_remarketing_only = Tracker.Properties.GoogleConversionRemarketingOnly ? true : false;     

                                $('body').prepend(
                                    '<script type="text/javascript" async="true" src="//www.googleadservices.com/pagead/conversion.js"><\/script>'
                                );
                            }
                        }
                    });
                }
            }
        }
    });
})();
